export default __webpack_public_path__ + "static/media/howwork-banner.bfdf1c52.jpg";